import type { UnknownAction } from 'redux';

import { resourceStoreTypes, resourceUpserters } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import * as actions from './taxFormsActions';
import type { TaxFormType } from './taxFormsTypes';

const initialState: QcsSyncResourceStore<TaxFormType> =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<TaxFormType>()();

function reducer(state = initialState, action: UnknownAction): typeof state {
  switch (true) {
    case actions.getTaxForms.match(action):
      return state.set('isLoading', true);
    case actions.getTaxFormsSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getTaxFormsFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);
    default:
      return state;
  }
}

export default reducer;
